import React, { useState, useContext, useEffect, useRef } from 'react'
import './Dashboard.css'
import DashboardLayout from './DashboardLayout'
import CheckBox from '../../product/components/atoms/CheckBox'
import { Button } from '@material-ui/core'
import PrimaryButton from '../../product/components/atoms/PrimaryButton'
import CustomDialog from '../../custom/components/organisms/Dialog'
import ProductContext from '../../product/context/product/productContext'
import { dateTimeFormatFunction, handleRedirectInternal } from '../../product/common/components'
import ProductCommonContext from '../../product/context/common/commonContext'
import AuthContext from '../../product/context/auth/authContext'
import NoRecordsFound from '../../product/components/atoms/NoRecordsFound'

import { useHistory } from 'react-router-dom'
import { Pagination } from '@material-ui/lab'

function SavedSearch() {
    const productContext = useContext(ProductContext)
    const productCommonContext = useContext(ProductCommonContext)
    const authContext = useContext(AuthContext)

    const { isAuthenticated } = authContext

    const history = useHistory()
    const [toggleDialog, setToggleDialog] = useState(false)
    const [currentPage, setCurrentPage] = useState(1)
    const [totalPage, setTotalPage] = useState(0)
    const [limit, setLimit] = useState(15)
    const [record, setRecord] = useState([])
    const [currentID, setCurrentID] = useState(0)

    const { responseStatus, getSavedSearch, saved_searches, removeSavedSearch } = productContext
    const { setSearchValue } = productCommonContext

    const loadTable = (page = currentPage) => {
        getSavedSearch({ page: page, limit: limit })
    }

    const removeRecord = (id) => {
        removeSavedSearch({ id })
        setTimeout(() => {
            loadTable()
        }, 500)
        setToggleDialog(false)
    }

    useEffect(() => {
        if (isAuthenticated) {
            loadTable()
        }
    }, [isAuthenticated])

    useEffect(() => {
        // console.log(saved_searches, 'from response status')
        if (saved_searches) {
            /*if (responseStatus.from === 'saved_search' && responseStatus.data) {*/
            //console.log(responseStatus.from, 'from is working')
            console.log(saved_searches.records, 'data is working')
            setRecord(saved_searches.records)
            setTotalPage(saved_searches.totalRecords)
            // setRecord(responseStatus.data.records)
            // setTotalPage(responseStatus.data.totalRecords)
            // }
        }
    }, [saved_searches])

    // SEARCH
    const getSearchBarObjet = (value) => {
        setSearchValue({
            filters: {
                searchbar: {
                    value: value,
                },
            },
        })
        handleRedirectInternal(history, 'search')
    }

    const onHandlePage = async (event, value) => {
        setCurrentPage(value)
        loadTable(value)
    }

    const changeDialogStatus = () => {
        setToggleDialog(!toggleDialog)
    }
    return (
        <DashboardLayout title={'My Saved Searches'}>
            <div className="dashboardInner mySavedSearches">
                {record.length ? (
                    <>
                        <h5 className="dashSubtitle">
                            {'You can find all your saved searches here'}
                            <br />
                            {'Saved Search Helps You Find Your Preferred Products Easily'}
                        </h5>
                        <div className="table-responsive dpTable">
                            <table className="table text-left">
                                <thead>
                                    <tr>
                                        <th scope="col">{'S No'}</th>
                                        <th scope="col">{'Title'}</th>
                                        <th scope="col">{'Date Added'}</th>
                                        <th scope="col">{'Action'}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {record.map((data, index) => (
                                        <tr key={`saved_${index}`}>
                                            <td>{index + 1}</td>
                                            <td>{data.search_text}</td>
                                            <td>{dateTimeFormatFunction(data.created_at)}</td>
                                            <td>
                                                <div className="d-flex justify-content-center ssActBtn">
                                                    <Button
                                                        onClick={() =>
                                                            getSearchBarObjet(data.search_text)
                                                        }
                                                    >
                                                        <span className="material-icons">
                                                            open_in_new
                                                        </span>
                                                    </Button>
                                                    <Button
                                                        onClick={() => {
                                                            setCurrentID(data.id)
                                                            setToggleDialog(true)
                                                        }}
                                                    >
                                                        <span className="material-icons">
                                                            delete
                                                        </span>
                                                    </Button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <Pagination
                                count={Math.ceil(totalPage / limit)}
                                page={currentPage}
                                onChange={onHandlePage}
                                siblingCount={3}
                                showFirstButton
                                showLastButton
                                boundaryCount={2}
                            />
                        </div>
                    </>
                ) : (
                    <NoRecordsFound />
                )}
            </div>

            <CustomDialog
                title={'Confirm Delete new'}
                open={toggleDialog}
                function={changeDialogStatus}
            >
                <h5>{'You are about to delete this saved search'}</h5>
                <h5>{'Please confirm if you want to continue with this action'}</h5>
                <div className="actionWrapper">
                    <Button onClick={() => setToggleDialog(false)}>{'No Cancel'}</Button>
                    <PrimaryButton
                        type="button"
                        onClick={() => removeRecord(currentID)}
                        label={'Yes Delete'}
                    />
                </div>
            </CustomDialog>
        </DashboardLayout>
    )
}

export default SavedSearch
